import { render, staticRenderFns } from "./SectionLocationV2.vue?vue&type=template&id=3c6531ec&"
import script from "./SectionLocationV2.vue?vue&type=script&lang=js&"
export * from "./SectionLocationV2.vue?vue&type=script&lang=js&"
import style0 from "./SectionLocationV2.vue?vue&type=style&index=0&id=3c6531ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsProjectOrganismLocation: require('/app/components/organisms/project/OrganismLocation.vue').default})
